import React from "react";
import styles from "./PolarAreaChart.module.scss";
import {
  AreaChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Area,
  ResponsiveContainer,
} from "recharts";

export default function PolarAreaChart({ data }: any) {
  // const dataRes = {
  //   labels: data?.map((item: any) => item?.country),
  //   datasets: [
  //     {
  //       label: "Countries",
  //       data: data.map((item: any) => item?.total),
  //       backgroundColor: [
  //         "#DB2777",
  //         "#0789AC",
  //         "#7C3AED",
  //         "#F59E0B",
  //         "#3A4CED",
  //       ],
  //       borderWidth: 1,
  //     },
  //   ],
  // };

  let chartData = data.map((each: any) => ({
    name: each.country,
    total: each.total,
  }));

  const options = {
    maintainAspectRatio: false,
    responsive: true
  };
  // console.log("chartDATA", data);

  // const options = {
  //   maintainAspectRatio: false,
  //   responsive: true,
  // };

  return (
    <div className={styles.component}>
      <div className={styles.polar}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            width={500}
            height={400}
            data={chartData}
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            <linearGradient id={chartData} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#003488" stopOpacity={0.12} />
              <stop offset="86%" stopColor="#003488" stopOpacity={0.02} />
            </linearGradient>
            <CartesianGrid strokeDasharray="0 0" vertical={false} />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Area
              type="monotone"
              dataKey="total"
              stroke="#003488"
              fill="rgba(52, 179, 241, 0.12)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
